<template>
    <div class="card-body">
        <b-container>
            <div class="form" v-if="!loading">
                <b-row>
                    <b-col>
                        <h4>Activar</h4>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="venta_abonados" v-model="managerLocal.nuevo_abono"/>
                                <label class="custom-control-label" for="venta_abonados">Activar nuevos abonados</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="renovar_abonados" v-model="managerLocal.renovar_abono"/>
                                <label class="custom-control-label" for="renovar_abonados">Activar renovación de abonados</label>
                            </div>
                        </div>

                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="futbol_base" v-model="managerLocal.futbol_base"/>
                                <label class="custom-control-label" for="futbol_base">Activar cantera</label>
                            </div>

                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="venta_simpatizantes"
                                    v-model="managerLocal.venta_simpatizantes"
                                    :disabled="simpatizantesBloqueado"
                                />
                                <label class="custom-control-label" for="venta_simpatizantes">
                                    Activar venta de {{ configuracion.simpatizantes }}
                                    <InfoToolTip
                                        v-if="simpatizantesBloqueado"
                                        class="ml-1"
                                        info="Para activar la venta de simpatizantes en un club SGA primero hay que configurar el id de producto de membresía en la temporada."
                                    />
                                </label>
                            </div>
                        </div>

                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_experiencias" v-model="managerLocal.activar_experiencias"/>
                                <label class="custom-control-label" for="activar_experiencias">Activar experiencias</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_pack" v-model="managerLocal.activar_pack"/>
                                <label class="custom-control-label" for="activar_pack">Activar pack</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="partidos" v-model="managerLocal.partidos"/>
                                <label class="custom-control-label" for="partidos">Activar eventos</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" data-cy="renovacion_futbol_base" id="renovacion_futbol_base" v-model="managerLocal.renovacion_futbol_base"/>
                                <label class="custom-control-label" for="renovacion_futbol_base">Activar renovación en cantera</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_acreditaciones" v-model="managerLocal.activar_acreditaciones"/>
                                <label class="custom-control-label" for="activar_acreditaciones">Activar acreditaciones</label>
                            </div>
                        </div>
                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_productos" v-model="managerLocal.activar_productos"/>
                                <label class="custom-control-label" for="activar_productos">Activar productos</label>
                            </div>
                        </div>
                        <div v-if="listaAbonados.activar_parcelas" class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="activar_parcelas" v-model="managerLocal.activar_parcelas"/>
                                <label class="custom-control-label" for="activar_parcelas">Activar parcelas</label>
                            </div>
                        </div>
                    </b-col>
                    <b-col>
                        <h4>Ocultar</h4>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_abonos" v-model="managerLocal.ocultar_abonos"/>
                                <label class="custom-control-label" for="ocultar_abonos">Ocultar nuevos abonados</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_renovar_abono" v-model="managerLocal.ocultar_renovar_abono"/>
                                <label class="custom-control-label" for="ocultar_renovar_abono">Ocultar renovación abonados</label>
                            </div>
                        </div>

                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_futbol_base" v-model="managerLocal.ocultar_futbol_base"/>
                                <label class="custom-control-label" for="ocultar_futbol_base">Ocultar cantera</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_simpatizantes" v-model="managerLocal.ocultar_simpatizantes"/>
                                <label class="custom-control-label" for="ocultar_simpatizantes">Ocultar venta de simpatizantes</label>
                            </div>
                        </div>

                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_experiencias" v-model="managerLocal.ocultar_experiencias"/>
                                <label class="custom-control-label" for="ocultar_experiencias">Ocultar experiencias</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_pack" v-model="managerLocal.ocultar_pack"/>
                                <label class="custom-control-label" for="ocultar_pack">Ocultar pack</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_eventos" v-model="managerLocal.ocultar_eventos"/>
                                <label class="custom-control-label" for="ocultar_eventos">Ocultar eventos</label>
                            </div>
                        </div>


                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_renovacion_futbol_base" v-model="managerLocal.ocultar_renovacion_futbol_base"/>
                                <label class="custom-control-label" for="ocultar_renovacion_futbol_base">Ocultar renovación en cantera</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_acreditaciones" v-model="managerLocal.ocultar_acreditaciones"/>
                                <label class="custom-control-label" for="ocultar_acreditaciones">Ocultar acreditaciones</label>
                            </div>
                        </div>

                        <div class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_productos" v-model="managerLocal.ocultar_productos"/>
                                <label class="custom-control-label" for="ocultar_productos">Ocultar productos</label>
                            </div>
                        </div>

                        <div v-if="listaAbonados.activar_parcelas" class="form-group margin-checkbox">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_parcelas" v-model="managerLocal.ocultar_parcelas"/>
                                <label class="custom-control-label" for="ocultar_parcelas">Ocultar parcelas</label>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="ocultar_afiliados" v-model="managerLocal.ocultar_afiliados"/>
                                <label class="custom-control-label" for="ocultar_afiliados">Ocultar afiliados</label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <Button @click="guardarOpciones" class="margin-guardar">Guardar</Button>
            </div>
            <LoaderComponent v-else />
        </b-container>
    </div>
</template>

<script>
    export default {
        props: ['manager', 'loading'],
        components: {
            InfoToolTip: () => import('@/components/common/InfoToolTip'),
        },
        data() {
            return {
                managerLocal: this.manager,
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            // En clubs SGA no se puede activar la venta de simpatizantes si la
            // temporada no tiene configurado el id de producto de membresía.
            simpatizantesBloqueado() {
                const esSga = Number(this.teatro?.sga) === 1;
                return esSga && !this.listaAbonados?.sga_membresia_product_id;
            },
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 700px) {
        .margin-checkbox {
            margin-top: 2.4rem;
        }

        .margin-guardar {
            margin-top: 2rem;
        }
    }
</style>
